export const DAILY_REWARD_MINOR = 10_000_000;
export const DAILY_REWARD_LABEL = (DAILY_REWARD_MINOR / 100).toLocaleString('en-US');
export const DAILY_REWARD_CADENCE = 'every 2 hours';

export const dailyCadence = (seconds) => {
  const unit = seconds % 86400 === 0 ? [86400, 'day'] : seconds % 3600 === 0 ? [3600, 'hour'] : seconds % 60 === 0 ? [60, 'minute'] : [1, 'second'];
  const count = seconds / unit[0];
  return `every ${count} ${unit[1]}${count === 1 ? '' : 's'}`;
};
export const dailyRewardDescription = (data) => data ? `${(data.reward_minor/100).toLocaleString('en-US', { maximumFractionDigits: 2 })} free V credits · ${dailyCadence(data.interval_seconds)}` : 'Free V credits';